<template>
  <div>
    <van-field v-model="val"
               :label="label"
               :placeholder="placeholder || label"
               :url="url"
               :required="required"
               :rules="[{required: required, message: '请输入' + label}]"
               @input="change"
    >
      <base-button slot="button" @click="showSheet">选择</base-button>
    </van-field>
    <van-action-sheet v-model="show" :actions="actions" :title="'选择 ' + label" @select="select" />
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入关键字后选择'
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    value: {
      type: String,
      default: ''
    },
    labelAttr: {
      type: String,
      default: 'name'
    },
    url: {
      type: String,
      default: '/client/dict'
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      val: this.value,
      actions: this.options || []
    }
  },
  watch: {
    value: function(value) {
      this.val = value
    },
    options: function(options) {
      this.actions = options
    },
    val: function(value) {
      this.$emit('change', value)
    }
  },
  methods: {
    change() {
      this.actions = []
      if (this.val) {
        const keywords = this.val.toString().trim()
        if (keywords && keywords.length >= 2) {
          setTimeout(() => {
            request.post(this.url, {
              name: keywords
            }).then(resp => {
              this.actions = resp.rows || []
              if (this.url === '/employee/dict' && this.actions.length > 0) {
                this.actions.forEach(item => {
                  item.name = item.dept_emp_name
                })
              }
            })
          }, 200)
        }
      }
    },
    showSheet() {
      if (this.val) {
        const keywords = this.val.toString().trim()
        if (!keywords || keywords.length < 2) {
          this.toast('请您至少输入两个字进行检索')
        } else {
          this.show = true
        }
      } else {
        this.toast('请您至少输入两个字进行检索')
      }
    },
    select(action) {
      this.val = action[this.labelAttr]
      this.$emit('change', this.val, action)
      this.show = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseSearchSelect.vue